import React, { Suspense, lazy, useState } from "react";
import { BrowserRouter, Routes, Route, useNavigate, Navigate } from "react-router-dom";
import { ProtectedRoute, SetupInterceptors } from "./components";
import {
  Dashboard,
  Configuration,
  NotFound,
  ConfigurationInitialSetup,
  Unauthorized,
} from "./pages";

import { useStateContext } from "./contexts/ContextProvider";

import "./App.css";

const NavigateFunctionComponent = () => {
  let navigate = useNavigate();
  const [ran, setRan] = useState(false);

  if (!ran) {
    SetupInterceptors(navigate);
    setRan(true);
  }
  return <></>;
};

const LazyInventory = lazy(() => import("./pages/Inventory"));
const LazyInventorySyncEvents = lazy(() =>
  import("./pages/InventorySyncEvents")
);
const LazyAgentEvents = lazy(() => import("./pages/AgentEvents"));
const LazyManageAssociations = lazy(() => import("./pages/ManageAssociations"));

const App = () => {
  const { user } = useStateContext();

  return (
    <BrowserRouter>
      <NavigateFunctionComponent />
      <div>
        <Routes>

          <Route element={<ProtectedRoute />}>
            {/* Dashboard */}
            {(!user?.tenantInfo.integrationId || user?.tenantInfo.integrationId.trim() === "") && (
              <Route path="/" element={<Navigate to="/configuration" replace />} />
            )}
            {user?.tenantInfo.integrationId && user?.tenantInfo.integrationId.trim() !== "" && (
              <Route path="/" element={<Dashboard />} />
            )}
            {(!user?.tenantInfo.integrationId || user?.tenantInfo.integrationId.trim() === "") && (
              <Route index element={<Navigate to="/configuration" replace />} />
            )}
            {user?.tenantInfo.integrationId && user?.tenantInfo.integrationId.trim() !== "" && (
              <Route index element={<Dashboard />} />
            )}
            {/* Pages */}
            {user?.tenantInfo.integrationId && user?.tenantInfo.integrationId.trim() !== "" && (
              <Route path="/dashboard" element={<Dashboard />} />
            )}
            <Route
              path="/configuration"
              element={
                !user?.tenantInfo.integrationId || user?.tenantInfo.integrationId.trim() === "" ? (
                  <ConfigurationInitialSetup />
                ) : (
                  <Configuration />
                )
              }
            />
            {user?.tenantInfo.integrationId && user?.tenantInfo.integrationId.trim() !== "" && (
              <Route
                path="/inventory"
                element={
                  <Suspense
                    fallback={
                      <gz-gz-progress-spinner indeterminate="true" value="26" />
                    }
                  >
                    <LazyInventory />
                  </Suspense>
                }
              />
            )}
            {user?.tenantInfo.integrationId && user?.tenantInfo.integrationId.trim() !== "" && (
              <Route
                path="/inventoryevents"
                element={
                  <Suspense
                    fallback={
                      <gz-gz-progress-spinner indeterminate="true" value="26" />
                    }
                  >
                    <LazyInventorySyncEvents />
                  </Suspense>
                }
              />
            )}
            {user?.tenantInfo.integrationId && user?.tenantInfo.integrationId.trim() !== "" && (
              <Route
                path="/agentevents"
                element={
                  <Suspense
                    fallback={
                      <gz-gz-progress-spinner indeterminate="true" value="26" />
                    }
                  >
                    <LazyAgentEvents />
                  </Suspense>
                }
              />
            )}
            {user?.tenantInfo.integrationId && user?.tenantInfo.integrationId.trim() !== "" && (
              <Route
                path="/manageassociations"
                element={
                  <Suspense
                    fallback={
                      <gz-gz-progress-spinner indeterminate="true" value="26" />
                    }
                  >
                    <LazyManageAssociations />
                  </Suspense>
                }
              />
            )}
          </Route>
          <Route path="/unauthorized" element={<Unauthorized />}></Route>
          <Route path="/*" element={<NotFound />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
};

export default App;
